import { useMutation, useQuery } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import { Link, useParams } from "react-router-dom";
import CertificatesView from "./CertificatesView";
import DocumentsView from "./DocumentsView";
import { FETCH_SUPPLIER, SAVE_SUPPLIER } from "./graphql";
import NDAView from "./onboarding/components/NDAView";
import SupplierPortalView from "./onboarding/components/SupplierPortalView";
import SupplierBaseInfoView from "./SupplierBaseInfoView";
import SupplierCompanyView from "./SupplierCompanyView";

const SupplierDetailPage = () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery(FETCH_SUPPLIER, {
    variables: { id },
  });
  const [save, saveRes] = useMutation(SAVE_SUPPLIER, {
    onCompleted() {
      Alert("success", "Main Products is updated.");
    },
    onError(error) {
      window.alert("Failed to update Main Products: " + parseError(error));
    },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const supplier = data.factory;

  function editMainProducts() {
    const newMainProducts = window.prompt(
      "Edit Main Products",
      supplier.mainProducts || "",
    );
    if (newMainProducts !== null) {
      save({
        variables: {
          id: supplier.id,
          mainProducts: newMainProducts,
        },
      });
    }
  }

  return (
    <Page
      title={supplier.nickName}
      backTo="./.."
      staticHeader
      rightButtons={
        <div className="space-x-6">
          {supplier.draftData && (
            <Link to={`/suppliers/onboarding/${supplier.id}`} target="_blank">
              Onboarding Detail
            </Link>
          )}

          <a
            href={`${
              process.env.REACT_APP_SERVER_ADMIN_URL +
              "csr/csrfactory/" +
              supplier.id
            }`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Admin
          </a>
        </div>
      }
    >
      <div className="grid grid-cols-12 gap-6 p-6">
        <div className="col-span-8 space-y-6">
          <SupplierBaseInfoView supplier={supplier} />

          <div className="card">
            <h3>System Companies</h3>
            <div>
              System companies are created after the supplier has been verified.
              This information is critical for purchase orders and invoicing.
              <br />
              This information is managed in Odoo.
            </div>
            <div className="mt-4 space-y-8">
              {supplier.odooPartners.map((i) => (
                <SupplierCompanyView key={i.id} odooPartner={i} />
              ))}
            </div>
          </div>
        </div>

        <div className="col-span-4 space-y-6 flex flex-col">
          <div className="card">
            <label>Supplier Class</label>
            <h5 className="mt-1">Class {supplier.supplierClass}</h5>
            <div className="mt-1 opacity-70">
              1级 - 核心供应商, 2级 - 配件产品供应商, 3级 - 周边产品供应商。
            </div>
            <div className="mt-2">
              <div className="flex items-center space-x-2">
                <label>Main Products:</label>
                <Button
                  loading={saveRes.loading}
                  edit
                  onClick={editMainProducts}
                />
              </div>
              <div className="mt-1 opacity-70">
                {supplier.mainProducts || "-"}
              </div>
            </div>
          </div>

          <div className="card">
            <label>Tracking Label</label>
            <h5 className="mt-1">{supplier.trackingLabel || "-"}</h5>
          </div>
          <NDAView supplier={supplier} />
          <DocumentsView supplier={supplier} />
          <CertificatesView supplier={supplier} />
          <SupplierPortalView supplier={supplier} hideInvitation />
        </div>
      </div>
    </Page>
  );
};

export default SupplierDetailPage;
